<div class="cart-table">
  <div class="cart-table__top">
    <div class="cart-table__block-count error">
      <div class="cart-table__count">
        <button class="up-arrow__click" (click)="increase()">
          <nb-icon icon="plus"></nb-icon>
        </button>
        <input nbInput [formControl]="inputFormControl" (keydown)="onKeyDown($event)" (input)="manualChange()" pattern="^\d+(\.\d{1,2})?$" inputmode="numeric" [decimal]="true" digitOnly>
        <button class="down-arrow__click" (click)="decrease()">
          <nb-icon icon="minus"></nb-icon>
        </button>
      </div>
      <div class="cart-table__pieces"><p>{{ cartProduct.unitHeader }}</p></div>
    </div>
  </div>
  <div class="packaging" *ngIf="multiplicityOrder > 1">{{ multiplicityHeader | lowercase }} {{ multiplicityOrder }} {{ cartProduct.unitHeader }}</div>
</div>
